import React, { useState } from 'react';
import qrcode from 'qrcode-generator';
import copy from 'clipboard-copy';
import styled from 'styled-components';
import { Text, VerticalGroup, HorizontalGroup, Textarea, Button } from '@libs/uikit/Components';
import { HG } from './HG';
const ErrorWrapper = styled.div`
    padding: 0 15px 0;
    font-size: 12px;
    color: #ed2c29;
`;

const ERROR_MSG =
    'System can not generate preview for your video. Verify information pasted in the field one more time, then click Check button again.';
const PLACEHOLDER = 'Specify VAST tag, VAST XML or VPAID Media file link';

const getType = (value) => {
    if (value === '') {
        return 'empty';
    }

    if (value[0] === '<') {
        return 'xml';
    }

    if (value.indexOf('http') === 0) {
        return 'link';
    }

    return 'error';
};
export const Editor = ({ onSubmit = () => {}, defaultValue = '', onCopy = () => {} }) => {
    const [value, setValue] = useState(defaultValue);
    const type = getType(value);
    const hasError = type === 'error';
    const isLink = type === 'link';
    const isEmpty = type === 'empty';

    const [host] = window.location.href.split('?response=');
    const link = isLink ? `${host}?response=${window.encodeURIComponent(value)}` : '';

    const qr = qrcode(0, 'L');
    qr.addData(link);
    qr.make();
    const qrCode = qr.createDataURL(6, 0);

    const generateLink = () => {
        copy(link);
        onCopy({ link });
    };

    const submit = () => onSubmit({ type, value });

    const onChange = (event) => setValue(event.target.value);

    return (
        <VerticalGroup>
            <Text pageTitle>
                Check your video
            </Text>
            <Text info>
                To confirm your VAST/VPAID tag works correctly, paste your VAST/VPAID link or VAST/VPAID XML into the
                text field below and click on the “Check” button.
            </Text>
            <div className="qr-wrapper"></div>
            <HG>
                <Textarea
                    style={{ height: '156px', flex: 1, "marginRight": 0, padding: '12px' }}
                    placeholder={PLACEHOLDER}
                    onChange={onChange}
                    value={value}
                ></Textarea>

                {isLink ? <img src={qrCode} alt="QRCode" style={{ width: '156px', height: '156px' }} /> : null}

                {hasError && <ErrorWrapper>{ERROR_MSG}</ErrorWrapper>}
            </HG>
            <HG>
                <Button secondary size="M" disabled={hasError || isEmpty} onClick={submit}>
                    Check
                </Button>
                <Button id="gen" size="XL" default disabled={!isLink} onClick={generateLink}>
                    Share test url
                </Button>
            </HG>
        </VerticalGroup>
    );
};
